import {Chip, ChipProps, Theme, useTheme} from "@mui/material";
import React, {forwardRef, useMemo} from "react";
import {BUILTIN_COLORS} from "../../api/Model";

export const defaultChipColor = '#f5f5f5';

export function chipColors(theme: Theme, color: string): {backgroundColor: string, color: string}  {
    switch (color.toLowerCase()) {
        case BUILTIN_COLORS.DEFAULT:
            return {
                backgroundColor: defaultChipColor,
                color: theme.palette.getContrastText(defaultChipColor)
            };
        case BUILTIN_COLORS.PRIMARY:
            return {
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.contrastText,
            };
        case BUILTIN_COLORS.SECONDARY:
            return {
                backgroundColor: theme.palette.secondary.light,
                color: theme.palette.secondary.contrastText,
            }
        default:
            return {
                backgroundColor: color,
                color: theme.palette.getContrastText(color)
            };
    }
}

export const ColorChip = forwardRef<HTMLDivElement, { color?: string } & Omit<ChipProps, 'color'>>(
    ({color = defaultChipColor, ...props}, ref) => {
        const theme = useTheme();

        const sx: ChipProps['sx'] = useMemo(() => {
            const colors = chipColors(theme, color);
            return ({
                ...colors,
                cursor: 'default',
                '& .MuiChip-icon': {
                    color: colors.color,
                },
            });
        }, [theme, color]);

        return (
            <Chip {...props} ref={ref} sx={sx}/>
        );
    }
);